document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.section-company')
    if (section) {
        const sliderEl = section.querySelector('.section-company__slider')
        const slider = new Swiper(sliderEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            autoplay: {
                delay: 3000,
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
        })

        slider.autoplay.stop()

        const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  console.log("Element is visible!");
                  
                  // Выполняем наши действия
                  slider.autoplay.start();
                  section.querySelector(`.section-company__nav-el[data-slide="0"]`)
                    .classList.add('section-company__nav-el--active');
                  
                  // Отключаем observer, если нужно срабатывание только один раз
                  observer.unobserve(entry.target);
                }
              });
            },
            {
              root: null,
              rootMargin: '0px',
              threshold: 0.2 // Срабатывает когда 20% элемента видно (аналог "top 80%")
            }
          );
          
          // Находим и наблюдаем за нашим элементом
          const targetElement = document.querySelector('.section-company__nav-slider');
          if (targetElement) {
            observer.observe(targetElement);
          }


        const sliderNavEl = section.querySelector('.section-company__nav-slider')
        const sliderNav = new Swiper(sliderNavEl, {
            slidesPerView: 'auto',
            spaceBetween: 16,
        })

        slider.on('transitionStart', function () {
            section.querySelector(`.section-company__nav-el[data-slide="${slider.realIndex}"]`).click()
        });


        const btnList = section.querySelectorAll('.section-company__nav-el')
        btnList.forEach((btn) => {
            btn.addEventListener('click', () => {
                if (!btn.classList.contains('section-company__nav-el--active')) {
                    const id = parseInt(btn.dataset.slide)
                    slider.slideTo(id)
                    section.querySelector('.section-company__nav-el--active').classList.remove('section-company__nav-el--active')
                    btn.classList.add('section-company__nav-el--active')
                    section.querySelector('.section-company__img-box--active').classList.remove('section-company__img-box--active')
                    section.querySelector(`.section-company__img-box[data-slide="${id}"]`).classList.add('section-company__img-box--active')
                    sliderNav.slideTo(id)
                }
            })
        })
    }
})